/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsskip2Inputs */

const en_openquestionsskip2 = /** @type {(inputs: Openquestionsskip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not important — skip`)
};

const pt_openquestionsskip2 = /** @type {(inputs: Openquestionsskip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não é importante — ignorar`)
};

/**
* | output |
* | --- |
* | "Not important — skip" |
*
* @param {Openquestionsskip2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsskip2 = /** @type {((inputs?: Openquestionsskip2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsskip2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsskip2(inputs)
	return pt_openquestionsskip2(inputs)
});
export { openquestionsskip2 as "openQuestionsSkip" }